import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getUserExperience } from "../services/experience.service";
import { userKeys } from "../queryKeys";
import { ExperienceResponse } from "../types/experience.types";

export const useUserExperience = (userId: string | null) => {
  const { i18n } = useTranslation();

  return useQuery<ExperienceResponse["data"], Error>({
    queryKey: [...userKeys.experience(userId!), i18n.language],
    queryFn: async () => {
      const response = await getUserExperience(userId!);
      return response.data;
    },
    enabled: !!userId,
  });
};
